define((require) => {
    "use strict";

    const
        CONSTANTS                           = require("ui/editor/email/Constants"),
        ImprovedView                        = require("editor/zbone/ImprovedView"),
        PopupMessageView                    = require("ui/editor/email/PopupMessageView.js"),
        template                            = require("ui/editor/email/RemoveIncompatibleWidgetsContentView.tpl");


    /**
     * Component representing content for the <tt>RemoveIncompatibleWidgetsView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsContentView
     *
     */
    return ImprovedView.extend({
        template,

        className: "remove-widgets",

        regions: {
            messageRegion: ".message-region"
        },

        events: {
            "click .remove-widgets-confirm": function() {
                this.model.set("state", CONSTANTS.REMOVE_WIDGETS);
            },

            "click .remove-widgets-cancel": function() {
                this.model.set("state", CONSTANTS.CLOSE);
            }
        },

        onRender() {
            this.messageRegion.show(new PopupMessageView({
                model: this.model
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/RemoveIncompatibleWidgetsContentView.js